import { render, staticRenderFns } from "./tab.vue?vue&type=template&id=7cc8fc1a"
import script from "./tab.vue?vue&type=script&lang=js"
export * from "./tab.vue?vue&type=script&lang=js"
import style0 from "./tab.vue?vue&type=style&index=0&id=7cc8fc1a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports